module.exports = __webpack_public_path__ + "img/clint2.3e5f19a8.png";